import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/stock-adjustment_/$id')({});
